

































































import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import CardResepPenunjang from "@/components/kunjunganPasien/CardResepPenunjang.vue";
import CardListSuket from "@/components/kunjunganPasien/CardListSuket.vue";
import CardListRekamMedis from "@/components/kunjunganPasien/CardListRekamMedis.vue";

@Component({
  components: {
    CardResepPenunjang,
    CardListSuket,
    CardListRekamMedis
  }
})
export default class CardDetailKunjungan extends Vue {
  @Prop() register: number;
  title = "";
  type = "";
  showTitle = false;
  selectedItem = null;
  clearDetail = [];
  panel = [];
  tab = "tab-rm";

  // listResep = [];
  // activeResep = {};

  mounted() {
    // this.getResepList(this.register).then(() => {
    //   const userResep = resepStore.resep.filter((resep) => {
    //     return resep.dokter.id == userModule.user.id;
    //   });
    //   if (userResep.length) {
    //     this.setActiveResep(userResep[userResep.length - 1]);
    //   }
    // });
    // storePenunjang.act_hasil_lab_byTrans();
  }

  // get listRo() {
  //   return storePenunjang.listhasilRadiologi;
  // }

  // get listResep() {
  //   return storeResepFarmasi.listResepFarmasi;
  // }
  // get listLab() {
  //   return storePenunjang.listhasilLab;
  // }
  // get stateuser() {
  //   return userModule.user;
  // }
  // setTypeLab() {
  //   storePenunjang.clear_hasil_ro();

  //   this.title = "Laboratorium";
  //   this.type = "lab";
  //   // alert(this.type);
  // }
  // setTypeRo() {
  //   // storePenunjang.clear_hasil_ro();
  //   this.title = "Radiologi";
  //   this.type = "ro";
  //   // alert(this.type);
  // }
  // detailHasil(val) {
  //   // console.log(val);
  //   // alert(val["tipe"]);
  //   if (val["tipe"] == "ro") {
  //     storePenunjang.clear_hasil_ro();
  //     storePenunjang.act_hasil_ro_byReg(val);
  //     // alert("RO");
  //   } else {
  //     // alert("LAB");
  //     // storePenunjang.act_hasil_lab_byTrans();
  //     // console.log("Hasil LAb");
  //   }
  // }
  // clearResep() {
  //   storeResepFarmasi.clear_detail_resepfarmasi();
  //   this.clearDetail = [];
  //   this.selectedItem = null;
  // }
}
